import {defer, isXml, parse} from "../../utils/core";
import {EVENTS} from "./constants";
import Path from "../../utils/path";
import { getDecode, xorDecoder, isJson } from "./decode";

function request(url, type, booksSetting) {

	let {requestCredentials, requestHeaders, encryptType, downloadToken} = booksSetting;
	
	var decode;
	var specialType = url.split(/[#?]/)[0].split(".").pop().trim();    
	var orgType = type;
	var isEncode = ( encryptType === 'enc01' );
	if(isEncode){
		type = 'binary';
	}


	var supportsURL = (typeof window != "undefined") ? window.URL : false; // TODO: fallback for url if window isn't defined
	var BLOB_RESPONSE = supportsURL ? "blob" : "arraybuffer";

	var deferred = new defer();

	var xhr = new XMLHttpRequest();

	//-- Check from PDF.js:
	//   https://github.com/mozilla/pdf.js/blob/master/web/compatibility.js
	var xhrPrototype = XMLHttpRequest.prototype;

	var header;

	if (!("overrideMimeType" in xhrPrototype)) {
		// IE10 might have response, but not overrideMimeType
		Object.defineProperty(xhrPrototype, "overrideMimeType", {
			value: function xmlHttpRequestOverrideMimeType() {}
		});
	}

	if(requestCredentials) {
		xhr.withCredentials = true;
	}

	xhr.onreadystatechange = handler;
	xhr.onerror = err;

	xhr.open("GET", url, true);

	for(header in requestHeaders) {
		xhr.setRequestHeader(header, requestHeaders[header]);
	}

	if(type == "json") {
		xhr.setRequestHeader("Accept", "application/json");
	}

	// If type isn"t set, determine it from the file extension
	if(!type) {
		type = new Path(url).extension;
	}

	if(type == "blob"){
		xhr.responseType = BLOB_RESPONSE;
	}


	if(isXml(type)) {
		// xhr.responseType = "document";
		xhr.overrideMimeType("text/xml"); // for OPF parsing
	}

	if(type == "xhtml") {
		// xhr.responseType = "document";
	}

	if(type == "html" || type == "htm") {
		// xhr.responseType = "document";
	}

	if(type == "binary") {
		xhr.responseType = "arraybuffer";
	}

	xhr.send();

	function err(e) {
		deferred.reject(e);
	}

	function handler() {
		if (this.readyState === XMLHttpRequest.DONE) {
			var responseXML = false;
			var r, enc, arr, rDecode;

			if(this.responseType === "" || this.responseType === "document") {
				responseXML = this.responseXML;
			}
	
			if (this.status === 200 || this.status === 0 || responseXML) { //-- Firefox is reporting 0 for blob urls
				
				if(isEncode){
					type = orgType || specialType;
					if(this.responseURL.includes("isDecodefault")){
						decode = getDecode(this.responseURL, downloadToken+"isDecodefault");
					}else{
						decode = getDecode(this.responseURL, downloadToken);
					}
				}
	
				if (!this.response && !responseXML) {
					deferred.reject({
						status: this.status,
						message : "Empty Response",
						stack : new Error().stack
					});
					return deferred.promise;
				}
	
				if(responseXML){
					r = this.responseXML;
				} else if(isXml(type)){
					enc = new TextDecoder("utf-8");
					arr = new Uint8Array(this.response);
					rDecode = enc.decode(arr);
					if(isJson(rDecode)){
						let error = JSON.parse(rDecode);
						deferred.reject(error);
					}else{
						if(isEncode){
							r = parse(xorDecoder(this.response, decode), "text/xml");
						}else{
							// xhr.overrideMimeType("text/xml"); // for OPF parsing
							// If this.responseXML wasn't set, try to parse using a DOMParser from text
							r = parse(this.response, "text/xml");
						}
					}								
				}else if(type == "xhtml"){
					enc = new TextDecoder("utf-8");
					arr = new Uint8Array(this.response);
					rDecode = enc.decode(arr);
					if(isJson(rDecode)){
						let error = JSON.parse(rDecode);
						deferred.reject(error);
					}else{
						if(isEncode){
							r = parse(xorDecoder(this.response, decode), "application/xhtml+xml");
						}else{
							r = parse(this.response, "application/xhtml+xml");
						}
					}				
				}else if(type == "html" || type == "htm"){
					enc = new TextDecoder("utf-8");
					arr = new Uint8Array(this.response);
					rDecode = enc.decode(arr);
					if(isJson(rDecode)){
						let error = JSON.parse(rDecode);
						deferred.reject(error);
					}else{
						if(isEncode){
							r = parse(xorDecoder(this.response, decode), "text/html");
						}else{
							r = parse(this.response, "text/html");
						}
					}				
				}else if(type == "json"){
					r = JSON.parse(this.response);
				}else if(type == "blob"){
	
					if(supportsURL) {
						r = this.response;
					} else {
						//-- Safari doesn't support responseType blob, so create a blob from arraybuffer
						r = new Blob([this.response]);
					}
	
				} else if(type == "binary"){
					if(isEncode){
						r = xorDecoder(this.response, decode);
					}else{
						r = this.response;
					}					
				} else{
					r = this.response;
				}
	
				deferred.resolve(r);

			} else {
				switch (this.status){
				case 404: deferred.reject({error_code:"id_err_301", error_message:"找不到檔案"});
							  break;
				case 401: deferred.reject({error_code:"id_err_501", error_message:"無權限"});
							  break;
				case 400: deferred.reject({error_code:"id_err_000", error_message:"錯誤的請求"});
							  break;
				default: enc = new TextDecoder("utf-8");
					arr = new Uint8Array(this.response);
					rDecode = enc.decode(arr);
					if(isJson(rDecode)){
						let error = JSON.parse(rDecode);
						deferred.reject(error);
					}else{
						deferred.reject({
							status: this.status,
							message : this.response,
							stack : new Error().stack
						});
					}
				}
			}
		}
	}

	return deferred.promise;
}

export default request;
